"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fnumber = fnumber;
const lang_1 = require("./lang");
const mround_1 = require("./mround");
// const precisionsz: string[] = ['', '.0', '.00', '.000', '.0000', '.00000', '.000000', '.0000000', '.00000000'];
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 8
 */
function fnumber(value, precision = 8, lang) {
    var _a;
    if (value === null) {
        return '';
    }
    // const s = value.toFixed(2);
    // let s = mround(value, precision).toFixed(precision);
    if (value % 1 === 0) {
        return value.toString();
    }
    const sep = ((_a = lang !== null && lang !== void 0 ? lang : this === null || this === void 0 ? void 0 : this.lang) !== null && _a !== void 0 ? _a : lang_1.defaultLang.current).decimalSeparator;
    return (0, mround_1.mround)(value, precision).toString().replace('.', sep);
}
//# sourceMappingURL=fnumber.js.map